const component = {
  props: ['isActive', 'selectCard', 'spend', 'spendPeriod'],
};

export default component;
